import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const UserNotactifService = {

 async getUsernotactif(name) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/getlist`,{name:name});
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
 
 async saveperson(form) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/saveperson`,{form});
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  
   async detailperson(userid) {
    try {
      const result = await axios.get(`${apiUrl}/Assignment/`+userid);
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
  async suivisortie(year,month,type) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suivisortie`,
        {
           year:year,
           month:month,
           type:type
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
   async suiviconge(year,month,type) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suiviconge`,
        {
           year:year,
           month:month,
           type:type
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
   async suiviaffectation(year,month) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suiviaffectation`,
        {
           year:year,
           month:month
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
  async suivirecrutment(year,month) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suivirecrutment`,
        {
           year:year,
           month:month
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
  async suiviintegration(year,month) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suiviintegration`,
        {
           year:year,
           month:month
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
   async suivifinancement(year,month) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suivifinancement`,
        {
           year:year,
           month:month
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
  async suivifinancementByDate(datedebut,datefin) {
    try {
      const result = await axios.post(`${apiUrl}/Usernotactif/suivifinancementbydate`,
        {
           datedebut:datedebut,
           datefin:datefin
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }, 
  

}

export default UserNotactifService;